import { CustomFieldType } from '@pedix-workspace/utils';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';
import { CustomField, CustomFieldDetail } from '@pedix-workspace/utils';
import { TranslocoDirective } from '@ngneat/transloco';
import { parseCustomFieldValue } from '@pedix-workspace/orders';

import {
  InputCheckboxGroupComponent,
  InputDateComponent,
  InputNumberComponent,
  InputTextComponent,
  SelectBoxComponent,
} from '@pedix-workspace/angular-ui-form-reactive';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';

@Component({
  selector: 'app-custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    InputCheckboxGroupComponent,
    InputTextComponent,
    InputNumberComponent,
    InputDateComponent,
    SelectBoxComponent,
    FormsModule,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class CustomFieldComponent implements OnInit {
  @Input() customField: CustomField;
  @Input() value: CustomFieldDetail['value'];
  @Input() displayErrors: boolean;

  @Output() valueChange = new EventEmitter<CustomFieldDetail['value']>();

  inputType: string;

  get checkboxValues(): string[] {
    return this.value as string[];
  }

  ngOnInit() {
    this.inputType = this.getInputType(this.customField.fieldType);
  }

  onValueChanged(value: CustomFieldDetail['value']) {
    const parsedValue = parseCustomFieldValue(value, this.customField.fieldType);

    this.valueChange.emit(parsedValue as CustomFieldDetail['value']);
  }

  private getInputType(fieldType: CustomFieldType): string {
    switch (fieldType) {
      case 'single-choice':
        return 'select-box';
      case 'multiple-choice':
        return 'checkboxes';
      default:
        return fieldType;
    }
  }
}
